import {isNullOrUndefined} from "../../services/Validator";

export default function SystemAppContentLayout({children}) {
    // Used in CoursesScreen to frame screen content

    // BUILD
    if (isNullOrUndefined(children))
        return null;
    return (
        <div className={"w-[480px] md:w-[540px] lg:w-[720px] flex flex-col justify-start items-center"}>
            {children}
        </div>
    );
}